import 'regenerator-runtime/runtime';
import { all } from 'redux-saga/effects';
import WatchCommon from '../Common/saga';
import WatchUser from '../User/saga';
import WatchInsurancePolicies from '../Insurance/saga';
import WatchRequestTypes from '../Request-Types/saga';
import WatchProjects from '../Projects/saga';
import WatchSubcontractor from '../Subcontractors/saga';
import WatchRoom from '../Rooms/saga';
import WatchModel from '../Model/saga';
import WatchWorkOrderType from '../Work-Order-Type/saga';
import WatchPhases from '../Projects/phase-saga';
import WatchLots from '../Lots/saga';
import WatchRFS from '../Request-Services/saga';
import WatchRegionMarket from '../Region-Market/saga';
import WatchWorkOrder from '../Work-Orders/saga';
import WatchAuth from '../Auth/saga';
import WatchBuilder from '../Builders/saga';
import WatchItemRepair from '../Items/saga';
import WatchCostCodes from '../CostCodes/saga';
import WatchSetting from '../Setting/saga';
import WatchTrade from '../Trades/saga';
import WatchHomeOwners from '../HomeOwners/saga';
import WatchPurchaseOrder from '../Purchase-Orders/saga';
import WatchPunchList from '../Punch-List/saga';
import WatchIzenda from '../izenda/saga';
import WatchActivities from '../Activities/saga';
import WatchMedia from '../MediaLibrary/saga';
import WatchDashBoard from '../Dashboard/saga';
// import WatchScheduleRFS from '../Schedule-Request-Service/saga';
import WatchDefaultConfig from '../DefaultConfig/saga';
export default function* rootSaga() {
  yield all([
    WatchCommon(),
    WatchUser(),
    WatchInsurancePolicies(),
    WatchRequestTypes(),
    WatchProjects(),
    WatchSubcontractor(),
    WatchRoom(),
    WatchModel(),
    WatchWorkOrderType(),
    WatchPhases(),
    WatchLots(),
    WatchRFS(),
    WatchRegionMarket(),
    WatchWorkOrder(),
    WatchAuth(),
    WatchBuilder(),
    WatchItemRepair(),
    WatchCostCodes(),
    WatchSetting(),
    WatchTrade(),
    WatchHomeOwners(),
    WatchPurchaseOrder(),
    WatchPunchList(),
    WatchIzenda(),
    WatchActivities(),
    WatchMedia(),
    WatchDashBoard(),
    WatchDefaultConfig()
    // WatchScheduleRFS()
  ]);
}



// WEBPACK FOOTER //
// ./src/portal_builder/saga.js